import { IconSpinner } from '@/components/Icon/icons/Spinner';
import { Spinner } from '@/components/Spinner/Spinner';

import { mergeClassNames } from '@/utils';

import styles from './SensorCard.module.css';

export const SensorCardSearching = () => {
  return (
    <div className={styles.searchingWrapper}>
      <div className={styles.spinner}>
        <div className={mergeClassNames(styles.circle)}></div>
        <div className={mergeClassNames(styles.circle)}></div>
        <div className={mergeClassNames(styles.circle)}></div>
        <div className={mergeClassNames(styles.circle)}></div>
        <div className={mergeClassNames(styles.circle)}></div>
        <div className={mergeClassNames(styles.circle)}></div>
        <div className={mergeClassNames(styles.circle)}></div>
        <div className={mergeClassNames(styles.circle)}></div>
      </div>{' '}
      Searching
    </div>
  );
};
